import React from 'react';
import { MODES } from './constants';

const ModeSelector = ({ activeMode, setActiveMode }) => {
  return (
    <div className="mode-selector">
      {MODES.map(mode => (
        <button
          key={mode}
          type="button"
          className={`mode-btn ${activeMode === mode ? 'active' : ''}`}
          onClick={() => setActiveMode(mode)}
        >
          {mode === 'HP' ? 'Hardpoint' : mode === 'SND' ? 'Search & Destroy' : 'Control'}
        </button>
      ))}
    </div>
  );
};

export default ModeSelector;

